import { Box, Typography, TextField, InputAdornment, Grid } from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import mentorImg1 from '../../Assets/mentorImg1.png';
import mentorImg2 from '../../Assets/mentorImg2.png';
import KenButton from '../../GlobalComponents/KenButton';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};
const imageData = [
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
  {
    image: mentorImg1,
  },
  {
    image: mentorImg2,
  },
];
const ImageUpload = (props: any) => {
  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ fontSize: 18, fontWeight: 550 }}>Choose an image</Typography>
        <Box sx={{ width: '100%', mx: 'auto', mt: 3, borderRadius: 10 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search"
            sx={{ borderRadius: 10 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <MicIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Grid container spacing={2} sx={{ height: 350, mt: 2 }} className="scrollbar-cusgray">
          {imageData?.map((val) => {
            return (
              <Grid item xs={2}>
                <img src={val.image} height={'100%'} width={'100%'} />
              </Grid>
            );
          })}
        </Grid>
        <hr style={{ border: '1px solid #BFCEFF', marginTop: 30 }} />
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={6} />
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <KenButton
                variant="text"
                sx={{
                  mt: 2,
                  borderRadius: '8px',
                  fontweight: 500,
                  backgroundColor: 'none',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  color: 'black',
                  width: 100,
                }}
                onClick={props.handleClose}
                fullWidth
              >
                Cancel
              </KenButton>
              <KenButton variant="contained" onClick={props.handleClose} style={{ width: 100, marginTop: 15, borderRadius: '7px' }} fullWidth>
                Done
              </KenButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ImageUpload;
